// extracted by mini-css-extract-plugin
module.exports = {"buttons":"FittingOrders_buttons__2dNfs","button":"FittingOrders_button__2_Rxu"};